import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import ListItemButton from '@mui/material/ListItemButton';
import { styled } from '@mui/material/styles';

import { drawerWidth, drawerWidthMD, drawerWidthCollapsed } from './Sidebar.constants';

// Main sidebar container
export const StyledSidebar = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  backgroundColor: '#fff',
  borderRight: '1px solid',
  borderColor: theme.palette.divider,
  transition: 'width 0s ease-in-out',
  width: `${drawerWidthMD}px`,
  [theme.breakpoints.up('xl')]: {
    width: `${drawerWidth}px`,
  },
  '&.collapsed': {
    width: `${drawerWidthCollapsed}px`,
  },
})) as typeof Box;

// Navigation item button
export const StyledNavItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{
  active?: boolean;
}>(({ theme, active }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '10px 12px',
  borderRadius: '8px',
  transition: 'all 0.2s',
  minHeight: '40px',
  color: theme.palette.text.primary,
  backgroundColor: '#fff',
  '&:hover': {
    color: '#26859C',
    backgroundColor: 'rgba(38, 133, 156, 0.08)',
  },
  ...(active && {
    backgroundColor: theme.palette.text.primary,
    color: '#fff',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    '&:hover': {
      backgroundColor: theme.palette.text.primary,
      color: '#fff',
    },
  }),
  '& .MuiListItemText-primary': {
    fontSize: '16px',
    fontWeight: active ? 600 : 400,
    color: 'inherit',
  },
  [theme.breakpoints.up('xl')]: {
    '& .MuiListItemText-primary': {
      fontSize: '18px',
    },
  },
})) as typeof ListItemButton;

// Group trigger button
export const StyledGroupTrigger = styled(ListItemButton)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  padding: '8px 12px',
  borderRadius: '8px',
  fontSize: '12px',
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: '0.05em',
  color: theme.palette.text.secondary,
  transition: 'color 0.2s',
  minHeight: '32px',
  '&:hover': {
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
  },
})) as typeof ListItemButton;

// Divider between nav groups
export const StyledDivider = styled(Divider)(({ theme }) => ({
  height: '1px',
  backgroundColor: theme.palette.divider,
  margin: '8px 12px',
}));

// Badge chip for nav items
export const StyledBadge = styled(Chip)(() => ({
  padding: '2px 6px',
  fontSize: '10px',
  fontWeight: 600,
  borderRadius: '9999px',
  backgroundColor: 'rgba(38, 133, 156, 0.1)',
  color: '#26859C',
  height: 'auto',
  '& .MuiChip-label': {
    padding: '0',
  },
}));
